// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xLDiIP {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  width: 100%;
  height: 100%;
}

.eR6lLn {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: var(--surface-neutral-white);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);
  border-radius: var(--radius-s);
  overflow: hidden;
  position: relative;
  min-height: 0;
  flex: 1;
}

.bel1ug {
  width: 100%;
  height: 48px;
  padding-left: var(--spacing-3);
  padding-right: var(--spacing-3);
  padding-top: var(--spacing-1-5);
  display: flex;
  align-items: flex-end;
  border-bottom: 1px solid var(--stroke-neutral-subtle);
}

.SOorTY {
  height: 36px;
  padding: var(--spacing-1);
  border-bottom: 2px solid var(--brand-tr-orange);
  text-align: center;
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary-medium);
}

.S_Ll4h {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: var(--spacing-2) var(--spacing-3) var(--spacing-3) var(--spacing-3);
  gap: var(--spacing-3);
}

.UJPBLH {
  height: 24px;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  display: none;
}

.KMi12_ {
  height: 24px;
  display: flex;
  align-items: center;
  gap: var(--spacing-1-5);
}

.j4z7f7 {
  font-family: var(--font-family-base);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-regular);
  color: var(--text-neutral-stronger);
  line-height: 24px;
}

.AbVikF {
  width: 24px;
  cursor: pointer;
  border: none;
  background: transparent;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
}

.ZURxpu {
  height: 24px;
  width: 24px;
  display: block;
}

.kxiWlZ {
  height: 24px;
  display: flex;
  align-items: center;
  gap: var(--spacing-1);
}

.aA7k19 {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-height: 0; /* Permite que o flex item encolha */
}

.QLp6zC {
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
  font-family: var(--font-family-base);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary-medium);
}

.hEUiAt {
  background: transparent;
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/AccountsPayable/AccountsPayable.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,2CAA2C;EAC3C,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,OAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,+CAA+C;EAC/C,kBAAkB;EAClB,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE,OAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,4EAA4E;EAC5E,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,uCAAuC;EACvC,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;EACP,aAAa,EAAE,oCAAoC;AACrD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".main {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  width: 100%;\n  height: 100%;\n}\n\n.section {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background: var(--surface-neutral-white);\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);\n  border-radius: var(--radius-s);\n  overflow: hidden;\n  position: relative;\n  min-height: 0;\n  flex: 1;\n}\n\n.header {\n  width: 100%;\n  height: 48px;\n  padding-left: var(--spacing-3);\n  padding-right: var(--spacing-3);\n  padding-top: var(--spacing-1-5);\n  display: flex;\n  align-items: flex-end;\n  border-bottom: 1px solid var(--stroke-neutral-subtle);\n}\n\n.title {\n  height: 36px;\n  padding: var(--spacing-1);\n  border-bottom: 2px solid var(--brand-tr-orange);\n  text-align: center;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-primary-medium);\n}\n\n.body {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  padding: var(--spacing-2) var(--spacing-3) var(--spacing-3) var(--spacing-3);\n  gap: var(--spacing-3);\n}\n\n.filters {\n  height: 24px;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  display: none;\n}\n\n.refreshWrapper {\n  height: 24px;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1-5);\n}\n\n.refreshText {\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-regular);\n  color: var(--text-neutral-stronger);\n  line-height: 24px;\n}\n\n.refreshButton {\n  width: 24px;\n  cursor: pointer;\n  border: none;\n  background: transparent;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  padding: 0;\n  margin: 0;\n}\n\n.refreshImage {\n  height: 24px;\n  width: 24px;\n  display: block;\n}\n\n.chipWrapper {\n  height: 24px;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n}\n\n.loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  min-height: 0; /* Permite que o flex item encolha */\n}\n\n.clearFiltersButton {\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-family: var(--font-family-base);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-primary-medium);\n}\n\n.iconContainer {\n  background: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `xLDiIP`,
	"section": `eR6lLn`,
	"header": `bel1ug`,
	"title": `SOorTY`,
	"body": `S_Ll4h`,
	"filters": `UJPBLH`,
	"refreshWrapper": `KMi12_`,
	"refreshText": `j4z7f7`,
	"refreshButton": `AbVikF`,
	"refreshImage": `ZURxpu`,
	"chipWrapper": `kxiWlZ`,
	"loader": `aA7k19`,
	"clearFiltersButton": `QLp6zC`,
	"iconContainer": `hEUiAt`
};
module.exports = ___CSS_LOADER_EXPORT___;
